import React, { useState, useEffect,useRef } from 'react';
import '../Customize_Css/AddVendor.css';
import add from '../Icons/Add.svg';
import deleteicon from '../Icons/delete.svg';
import uploadicon from '../Icons/upload white.svg';
import location from '../Icons/location.svg';
import arrow from '../Icons/arrow.svg';
import axios from 'axios';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select, { components } from 'react-select';
import { useNavigate, useParams } from 'react-router-dom';
import removeIcon from '../Icons/Close-white.svg';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";
const ProductCheckboxOption = (props) => (
  <components.Option {...props}>
    <span className="vendor-product-option">
      <input type="checkbox" checked={props.isSelected} readOnly tabIndex={-1} />
      {props.label}
    </span>
  </components.Option>
);

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl, iconUrl, shadowUrl });


const UpdateProductVendor = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');
  const { id: productVendorId } = useParams();
  const navigate = useNavigate();
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const goBackToVendors = () => {
    if (epicxTenantId) navigate(`/viewvendor/${epicxTenantId}`);
    else navigate(-1);
  };

  const [categories, setCategories] = useState([]);
  const [timeAvailabilitySlots, setTimeAvailabilitySlots] = useState([]);
  const [daySlots, setDaySlots] = useState([]);
  const [documents, setDocuments] = useState([{
    name: '',
    number: '',
    upload: null,
    type: '',
    expiryDate: '',
    preview: null,
  }]);
  const [isOpen, setIsOpen] = useState(false);
  const [categoriesOpenAbove, setCategoriesOpenAbove] = useState(false);
  const categoriesSelectRef = useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [vendorName, setVendorName] = useState('');
  const [shopName, setShopName] = useState('');
  const [GSTNumber, setGstNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  // const [useMyLocation, setUseMyLocation] = useState('');
  const [useMyLocation, setUseMyLocation] = useState({ latitude: '', longitude: '' });
  const [currentLocation, setCurrentLocation] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [address, setAddress] = useState('');
  const [consumable, setConsumable] = useState('Perishable');
  const [productsByCategory, setProductsByCategory] = useState({});
  const [selectedProducts, setSelectedProducts] = useState({});
  const [isLocationPicked, setIsLocationPicked] = useState(false);
  const [files, setFiles] = useState({ profileImage: null });
  const [errors, setErrors] = useState({});
  const [validFields, setValidFields] = useState({});

    // Map States
    const [isMapOpen, setIsMapOpen] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [manualLat, setManualLat] = useState("");
    const [manualLng, setManualLng] = useState("");
    const mapRef = useRef(null);
    const mapCenter = [11.0168, 76.9558]; // Coimbatore default
    const mapZoom = 13;


      // Map Click Handler
      function MapClickHandler({ onSelect }) {
        useMapEvents({
          click(e) {
            const { lat, lng } = e.latlng;
            onSelect({ lat, lng });
          },
        });
        return null;
      }
    
      const updateLocation = (loc) => {
        setSelectedLocation(loc);
        setManualLat(loc.lat.toFixed(6));
        setManualLng(loc.lng.toFixed(6));
      };
    
      const handleGeocode = async () => {
        if (!searchQuery.trim()) return;
        try {
          const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}`);
          const data = await res.json();
          if (data.length === 0) {
            toast.error("Location not found");
            return;
          }
          const { lat, lon } = data[0];
          const newLoc = { lat: parseFloat(lat), lng: parseFloat(lon) };
          updateLocation(newLoc);
          mapRef.current?.setView(newLoc, 16);
        } catch (err) {
          toast.error("Search failed");
        }
      };
        useEffect(() => {
          if (isMapOpen && mapRef.current) {
            setTimeout(() => mapRef.current.invalidateSize(), 300);
          }
        }, [isMapOpen]);
      
        // Confirm location from map
        const confirmLocation = () => {
          if (!selectedLocation) return;
          setUseMyLocation({
            latitude: selectedLocation.lat.toString(),
            longitude: selectedLocation.lng.toString()
          });
          validateField('useMyLocation', { latitude: selectedLocation.lat.toString(), longitude: selectedLocation.lng.toString() });
          toast.success(
            <div className="vendor-location-toast">
              <strong>Location saved</strong>
              <span>{selectedLocation.lat.toFixed(6)}, {selectedLocation.lng.toFixed(6)}</span>
            </div>
          );
          setIsMapOpen(false);
        };
        // Load existing location on edit
        useEffect(() => {
          if (useMyLocation.latitude && useMyLocation.longitude) {
            const lat = parseFloat(useMyLocation.latitude);
            const lng = parseFloat(useMyLocation.longitude);
            if (!isNaN(lat) && !isNaN(lng)) {
              setSelectedLocation({ lat, lng });
              setManualLat(lat.toFixed(6));
              setManualLng(lng.toFixed(6));
            }
          }
        }, [useMyLocation]);
  // Predefined document name options
  const documentNameOptions = [
    'Aadhar Card',
    'PAN Card',
    'GST Certificate',
    'FSSAI License',
    'Trade License'
  ];

  const Input = styled('input')({
    display: 'none',
  });

  const handleFileRemove = (fileType) => {
    setFiles((prevFiles) => ({
      ...prevFiles,
      [fileType]: null
    }));
    validateField('profileImage', null);
  };

  const documentTypeAccept = {
    pdf: '.pdf,application/pdf',
    doc: '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    jpg: '.jpg,image/jpeg',
    jpeg: '.jpeg,.jpg,image/jpeg',
    png: '.png,image/png',
  };

  const fileMatchesDocumentType = (file, type) => {
    if (!file || !type) return false;
    const name = file.name.toLowerCase();
    const mime = (file.type || '').toLowerCase();
    if (type === 'pdf') return name.endsWith('.pdf') || mime === 'application/pdf';
    if (type === 'doc') return name.endsWith('.doc') || name.endsWith('.docx') || mime.includes('word') || mime.includes('msword');
    if (type === 'png') return name.endsWith('.png') || mime === 'image/png';
    if (type === 'jpg' || type === 'jpeg') return name.endsWith('.jpg') || name.endsWith('.jpeg') || mime === 'image/jpeg';
    return false;
  };

  const handleFileChange = (index, event) => {
    const file = event.target.files[0];
    event.target.value = '';
    const selectedType = documents[index]?.type;
    if (!selectedType) {
      setErrors((prev) => ({ ...prev, [`documentupload${index}`]: 'Select a document type before uploading' }));
      return;
    }
    if (!file) return;
    if (!fileMatchesDocumentType(file, selectedType)) {
      setErrors((prev) => ({ ...prev, [`documentupload${index}`]: `Only ${selectedType.toUpperCase()} files can be uploaded` }));
      setValidFields((prev) => ({ ...prev, [`documentupload${index}`]: false }));
      return;
    }
    const newDocuments = [...documents];
    const previewUrl = file.type === 'application/pdf' || file.type.startsWith('image/') ? URL.createObjectURL(file) : null;
    newDocuments[index] = {
      ...newDocuments[index],
      upload: file,
      preview: previewUrl || null
    };
    setDocuments(newDocuments);
    validateField(`documentupload${index}`, file);
  };

  const handleProfileImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setFiles((prev) => ({ ...prev, profileImage: { file, preview: previewUrl } }));
      validateField('profileImage', file);
    }
  };

  const handleClearFile = (index) => {
    const newDocuments = [...documents];
    if (newDocuments[index].upload) {
      URL.revokeObjectURL(newDocuments[index].preview); // Clean up object URL
    }
    newDocuments[index] = {
      ...newDocuments[index],
      upload: null,
      preview: null,
    };
    setDocuments(newDocuments);
    validateField(`documentupload${index}`, null);
  };

  const handleButtonClick = (time) => {
    setTimeAvailabilitySlots([time]);
    validateField('timeAvailabilitySlots', [time]);
  };

  const handleDaysButtonClick = (day) => {
    setDaySlots(prevDays =>
      prevDays.includes(day)
        ? prevDays.filter(d => d !== day)
        : [...prevDays, day]
    );
    validateField('daySlots', daySlots.includes(day) ? daySlots.filter(d => d !== day) : [...daySlots, day]);
  };

  const handleChange = (index, field, value) => {
    const newDocuments = [...documents];
    newDocuments[index][field] = value;
    if (field === 'type' && newDocuments[index].upload && !fileMatchesDocumentType(newDocuments[index].upload, value)) {
      newDocuments[index].upload = null;
      newDocuments[index].preview = null;
      setErrors((prev) => ({ ...prev, [`documentupload${index}`]: value ? `Only ${value.toUpperCase()} files can be uploaded` : '' }));
      setValidFields((prev) => ({ ...prev, [`documentupload${index}`]: false }));
    }
    setDocuments(newDocuments);
    validateField(`document${field}${index}`, value);
  };

  const addRow = () => {
    setDocuments([...documents, {
      name: '',
      number: '',
      upload: null,
      type: '',
      expiryDate: ''
    }]);
  };

  const deleteRow = (index) => {
    if (documents.length > 1) {
      const newDocuments = documents.filter((_, i) => i !== index);
      if (documents[index].upload && documents[index].preview) {
        URL.revokeObjectURL(documents[index].preview); // Clean up object URL
      }
      setDocuments(newDocuments);
    } else {
      toast.error('At least one document row is required.');
    }
  };

  const handleConsumableClick = (type) => {
    setConsumable(type);
    validateField('consumable', type);
  };

  const toggleOption = (value) => {
    setSelectedOptions((prevSelected) => {
      const newSelected = prevSelected.includes(value)
        ? prevSelected.filter((item) => item !== value)
        : [...prevSelected, value];
      if (!prevSelected.includes(value)) {
        const category = categories.find(cat => cat._id === value);
        if (category && !productsByCategory[category.categoryName]) {
          getProductsByCategory(category.categoryName);
        }
      }
      return newSelected;
    });
    validateField('categories', selectedOptions.includes(value) ? selectedOptions.filter((item) => item !== value) : [...selectedOptions, value]);
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => {
      if (!prev) {
        setTimeout(() => {
          const el = categoriesSelectRef.current;
          if (el) {
            const rect = el.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            setCategoriesOpenAbove(spaceBelow < 200);
          }
        }, 0);
      } else {
        setCategoriesOpenAbove(false);
      }
      return !prev;
    });
  };

  useEffect(() => {
    if (!isOpen) return undefined;
    const handleOutside = (event) => {
      if (categoriesSelectRef.current && !categoriesSelectRef.current.contains(event.target)) {
        setIsOpen(false);
        setCategoriesOpenAbove(false);
      }
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [isOpen]);

  const handleLocationClick = () => {
    if (!navigator.geolocation) {
      setErrors((prev) => ({ ...prev, useMyLocation: 'Geolocation is not supported by this browser.' }));
      setIsLocationPicked(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        // const locationString = `Latitude: ${latitude}, Longitude: ${longitude}`;
        // setUseMyLocation(locationString);
        // setIsLocationPicked(true);
        // validateField('useMyLocation', locationString);
        setUseMyLocation({ latitude: latitude.toString(), longitude: longitude.toString() });
        setIsLocationPicked(true);
        validateField('useMyLocation', { latitude, longitude });
      },
      (error) => {
        let errorMessage = 'Error getting location';
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'Please enable location permissions in your browser settings.';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Location information is unavailable.';
            break;
          case error.TIMEOUT:
            errorMessage = 'The request to get user location timed out.';
            break;
        }
        setErrors((prev) => ({ ...prev, useMyLocation: errorMessage }));
        setIsLocationPicked(false);
      },
      { timeout: 10000, enableHighAccuracy: true }
    );
  };

  const handleProductChange = (categoryId, productIds) => {
    setSelectedProducts((prevSelectedProducts) => ({
      ...prevSelectedProducts,
      [categoryId]: productIds
    }));
    validateField(`products${categoryId}`, productIds);
  };

  const validateField = (id, value) => {
    const isEmpty = (val) => !val || val.toString().trim() === '';
    const gstPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
    const phonePattern = /^[0-9]{10}$/;
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    const validationRules = {
      vendorName: { message: 'Vendor Name is required', validator: (val) => !isEmpty(val) },
      GSTNumber: { 
        message: 'GST Number must be 15 characters and follow the correct format (e.g., 22ABCDE1234F1Z5)', 
        validator: (val) => !isEmpty(val) && gstPattern.test(val) 
      },
      phoneNumber: { 
        message: 'Phone Number must be 10 digits', 
        validator: (val) => !isEmpty(val) && phonePattern.test(val) 
      },
      country: { message: 'Please select a country', validator: (val) => !isEmpty(val) },
      state: { message: 'Please select a state', validator: (val) => !isEmpty(val) },
      city: { message: 'Please select a city', validator: (val) => !isEmpty(val) },
      // useMyLocation: { message: 'You must pick your location', validator: (val) => !isEmpty(val) },
      useMyLocation: { 
        message: 'You must pick your location', 
        validator: (val) => val && !isEmpty(val.latitude) && !isEmpty(val.longitude) 
      },
      currentLocation: { message: 'Current Location is required', validator: (val) => !isEmpty(val) },
      emailAddress: { 
        message: 'Please enter a valid Email Address', 
        validator: (val) => !isEmpty(val) && emailPattern.test(val) 
      },
      address: { message: 'Address is required', validator: (val) => !isEmpty(val) },
      consumable: { message: 'Consumable selection is required', validator: (val) => !isEmpty(val) },
      timeAvailabilitySlots: { message: 'At least one Time Availability Slot must be selected', validator: (val) => val.length > 0 },
      daySlots: { message: 'At least one Day Slot must be selected', validator: (val) => val.length > 0 },
      categories: { message: 'Please select at least one category', validator: (val) => val.length > 0 },
      profileImage: { message: 'Profile Image is required', validator: (val) => val !== null },
      shopName: { message: 'Shop Name is required', validator: (val) => !isEmpty(val) },
    };

    documents.forEach((doc, index) => {
      validationRules[`documentname${index}`] = { message: `Document Name is required for document ${index + 1}`, validator: (val) => !isEmpty(val) };
      validationRules[`documentnumber${index}`] = { message: `Document Number is required for document ${index + 1}`, validator: (val) => !isEmpty(val) };
      validationRules[`documenttype${index}`] = { message: `Document Type is required for document ${index + 1}`, validator: (val) => !isEmpty(val) };
      validationRules[`documentupload${index}`] = { message: `File upload is required for document ${index + 1}`, validator: (val) => val !== null };
    });

    selectedOptions.forEach((categoryId) => {
      validationRules[`products${categoryId}`] = { 
        message: `Please select at least one product for category ${categories.find(cat => cat._id === categoryId)?.categoryName || ''}`, 
        validator: (val) => val && val.length > 0 
      };
    });

    const rule = validationRules[id];
    if (!rule) return;

    const isValid = rule.validator(value);
    setErrors((prev) => isValid ? { ...prev, [id]: '' } : { ...prev, [id]: rule.message });
    setValidFields((prev) => isValid ? { ...prev, [id]: true } : { ...prev, [id]: false });
  };

  const validateForm = () => {
    let isValid = true;
    const fieldsToValidate = [
      'vendorName', 'GSTNumber', 'phoneNumber', 'country', 'state', 'city', 'useMyLocation', 'currentLocation',
      'emailAddress', 'address', 'consumable', 'timeAvailabilitySlots', 'daySlots', 'categories', 'profileImage', 'shopName'
    ];

    fieldsToValidate.forEach((id) => {
      const value = id === 'timeAvailabilitySlots' ? timeAvailabilitySlots :
                    id === 'daySlots' ? daySlots :
                    id === 'categories' ? selectedOptions :
                    id === 'profileImage' ? files.profileImage?.file || files.profileImage :
                    id === 'useMyLocation' ? useMyLocation :
                    eval(id);
      validateField(id, value);
      if (errors[id]) isValid = false;
    });

    documents.forEach((doc, index) => {
      validateField(`documentname${index}`, doc.name);
      validateField(`documentnumber${index}`, doc.number);
      validateField(`documenttype${index}`, doc.type);
      validateField(`documentupload${index}`, doc.upload || doc.preview);
      if (errors[`documentname${index}`] || errors[`documentnumber${index}`] || errors[`documenttype${index}`] || errors[`documentupload${index}`]) isValid = false;
    });

    selectedOptions.forEach((categoryId) => {
      validateField(`products${categoryId}`, selectedProducts[categoryId]);
      if (errors[`products${categoryId}`]) isValid = false;
    });

    return isValid;
  };

  const handleUpdateVendor = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      toast.error('Please fix the validation errors before submitting.');
      return;
    }

    const formData = new FormData();
    if (!epicxTenantId) {
      toast.error('Tenant ID is not provided');
      return;
    }

    formData.append("vendorName", vendorName);
    formData.append("shopName", shopName);
    formData.append("GSTNumber", GSTNumber);
    formData.append("phoneNumber", phoneNumber);
    formData.append("country", country);
    formData.append("state", state);
    formData.append("city", city);
    // formData.append("useMyLocation", useMyLocation);
    formData.append("useMyLocation", JSON.stringify(useMyLocation));
    formData.append("currentLocation", currentLocation);
    formData.append("emailAddress", emailAddress);
    formData.append("address", address);
    formData.append("consumable", consumable);
    formData.append("timeAvailabilitySlots", JSON.stringify(timeAvailabilitySlots));
    formData.append("daySlots", JSON.stringify(daySlots));

    if (files.profileImage && files.profileImage.file) {
      formData.append("profileImage", files.profileImage.file);
    }

    const docs = documents.map((doc) => ({
      documentName: doc.name,
      documentNumber: doc.number,
      documentType: doc.type,
      documentExpiryDate: doc.expiryDate,
    }));
    formData.append("documents", JSON.stringify(docs));

    documents.forEach((doc, index) => {
      if (doc.upload) {
        formData.append(`documentFiles[${index}]`, doc.upload);
      }
    });

    const categoriesPayload = selectedOptions.map((categoryId) => {
      const category = categories.find((cat) => cat._id === categoryId);
      return {
        categoryId,
        categoryName: category?.categoryName || "",
      };
    });
    formData.append("categories", JSON.stringify(categoriesPayload));

    const productsByCategoryPayload = selectedOptions.reduce((acc, categoryId) => {
      const category = categories.find((cat) => cat._id === categoryId);
      const categoryName = category?.categoryName;
      if (categoryName && selectedProducts[categoryId]) {
        const productList = selectedProducts[categoryId].map((productId) => {
          const product = productsByCategory[categoryName]?.find((p) => p._id === productId);
          return {
            productId,
            productName: product?.productName || "Unknown",
            statusValue: 1,
          };
        });
        acc[categoryName] = productList;
      }
      return acc;
    }, {});
    formData.append("productsByCategory", JSON.stringify(productsByCategoryPayload));

    try {
      const response = await axios.put(
        `${BASE_URL}/vendor/api/vendor/${epicxTenantId}/${productVendorId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${AuthorizationToken}`,
          },
        }
      );
      console.log("Vendor updated successfully:", response.data);
      toast.success("Product Vendor updated successfully");
      navigate(`/viewvendor/${epicxTenantId}`, { state: { openVendorId: productVendorId } });
    } catch (error) {
      console.error("Error updating vendor:", error);
      toast.error("Error updating vendor. Please try again.");
    }
  };

  useEffect(() => {
    const fetchVendorData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}/${productVendorId}`, {
          headers: { Authorization: `Bearer ${AuthorizationToken}` },
        });
        const vendor = response.data.vendor;
        if (vendor) {
          setVendorName(vendor.vendorName || '');
          setShopName(vendor.shopName || '');
          setGstNumber(vendor.GSTNumber || '');
          setPhoneNumber(vendor.phoneNumber || '');
          setEmailAddress(vendor.emailAddress || '');
          const savedCountry = (vendor.country || '').trim();
          const matchedCountry = ['India'].find((item) => item.toLowerCase() === savedCountry.toLowerCase());
          const nextCountry = matchedCountry || savedCountry || 'India';
          setCountry(nextCountry);
          setErrors((prev) => ({ ...prev, country: '' }));
          setValidFields((prev) => ({ ...prev, country: true }));
          setState(vendor.state || '');
          setCity(vendor.city || '');
          // setUseMyLocation(vendor.useMyLocation || '');
          const vendorLoc = vendor.useMyLocation || { latitude: '', longitude: '' };
          setUseMyLocation(vendorLoc);
          if (vendorLoc.latitude && vendorLoc.longitude) setIsLocationPicked(true);
          setCurrentLocation(vendor.currentLocation || '');
          setAddress(vendor.address || '');
          setTimeAvailabilitySlots(vendor.timeAvailabilitySlots || []);
          setDaySlots(vendor.daySlots || []);
          setConsumable(vendor.consumable || 'Perishable');
          const toDateInput = (value) => {
            if (!value) return '';
            const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
            return match ? match[1] : '';
          };
          setDocuments(vendor.documents.map(doc => ({
            name: doc.documentName || '',
            number: doc.documentNumber || '',
            upload: null,
            type: doc.documentType || '',
            expiryDate: toDateInput(doc.documentExpiryDate),
            preview: doc.documentFile || null
          })) || [{ name: '', number: '', upload: null, type: '', expiryDate: '' }]);
          setFiles({ profileImage: vendor.profileImage ? { name: 'Existing Image', preview: vendor.profileImage } : null });

          const categoriesWithId = vendor.categories.map(category => ({
            _id: category.categoryId,
            categoryName: category.categoryName,
          }));
          setCategories(categoriesWithId);
          setSelectedOptions(categoriesWithId.map(category => category._id));

          const selectedProds = {};
          Object.keys(vendor.productsByCategory).forEach(categoryName => {
            const categoryId = categoriesWithId.find(cat => cat.categoryName === categoryName)?._id;
            if (categoryId) {
              selectedProds[categoryId] = vendor.productsByCategory[categoryName].map(product => product.productId);
            }
          });
          setSelectedProducts(selectedProds);

          categoriesWithId.forEach(category => {
            getProductsByCategory(category.categoryName);
          });
        }
      } catch (error) {
        console.error("Error fetching vendor data:", error);
        toast.error("Error fetching vendor data.");
      }
    };

    fetchVendorData();
  }, [epicxTenantId, productVendorId]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}/categories`, {
          headers: { Authorization: `Bearer ${AuthorizationToken}` },
          params: { categoryType: consumable }
        });
        const newCategories = response.data.map(cat => ({
          _id: cat._id,
          categoryName: cat.categoryName
        }));
        setCategories(prev => [...new Set([...prev, ...newCategories])]);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, [epicxTenantId, consumable]);

  const getProductsByCategory = async (categoryName) => {
    try {
      const response = await axios.get(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}/products`, {
        headers: { Authorization: `Bearer ${AuthorizationToken}` },
        params: { categoryName }
      });
      setProductsByCategory(prevState => ({
        ...prevState,
        [categoryName]: response.data.map(product => ({
          _id: product._id,
          productName: product.productName
        }))
      }));
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const getAvailableDocumentNames = (currentIndex) => {
    const selectedNames = documents
      .filter((_, index) => index !== currentIndex)
      .map(doc => doc.name)
      .filter(name => name);
    return documentNameOptions.filter(name => !selectedNames.includes(name));
  };

  const renderDocumentPreview = (doc) => {
    if (doc.upload) {
      if (doc.upload.type === 'application/pdf') {
        return <iframe src={doc.preview} title="PDF Preview" style={{ width: '100px', height: '100px', marginTop: '10px' }} />;
      } else if (doc.upload.type.includes('msword') || doc.upload.type.includes('officedocument') || doc.upload.type.includes('excel')) {
        return <p style={{ marginTop: '10px' }}>Preview not available for {doc.upload.name}</p>;
      } else if (doc.upload.type.startsWith('image/')) {
        return <img src={doc.preview} alt="Document Preview" style={{ width: '100px', height: '100px', marginTop: '10px' }} />;
      }
    } else if (doc.preview) {
      // Assuming existing preview is a URL to an image or PDF
      if (doc.type === 'pdf') {
        return <iframe src={doc.preview} title="PDF Preview" style={{ width: '100px', height: '100px', marginTop: '10px' }} />;
      } else if (doc.type === 'doc' || doc.type === 'docx' || doc.type === 'xls' || doc.type === 'xlsx') {
        return <p style={{ marginTop: '10px' }}>Preview not available for existing {doc.name}</p>;
      } else {
        return <img src={doc.preview} alt="Document Preview" style={{ width: '100px', height: '100px', marginTop: '10px' }} />;
      }
    }
    return null;
  };

  return (
    <>
      <Sidebar />
      <div className="vendor-form-page">
        <div className="vendor-form-shell">
          <header className="vendor-form-hero">
            <div>
              <p className="vendor-form-kicker">Vendors</p>
              <h1>Update Product Vendor</h1>
              <p>Review and update shop, contact, location, documents, and products.</p>
            </div>
            <button type="button" className="vendor-form-back-btn" onClick={goBackToVendors}>
              Back to Vendors
            </button>
          </header>
          <div className="vendor-form-card">
            <div className="vendor-form-card-head">
              <div>
                <h2>Product Vendor Information</h2>
                <p>Shop name, contact details, and location.</p>
              </div>
            </div>
            <div className="vendor-form-card-body">
              <div className='row'>
                <div className='col-md-4'>
                  <div className="form-group">
                    <label htmlFor="vendorName">Vendor Name</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.vendorName ? 'is-invalid' : validFields.vendorName ? 'is-valid' : ''}`}
                      id="vendorName"
                      placeholder="Enter vendor name"
                      value={vendorName}
                      onChange={(e) => setVendorName(e.target.value)}
                      onBlur={(e) => validateField('vendorName', e.target.value)}
                    />
                    {errors.vendorName && <small className="text-danger">{errors.vendorName}</small>}
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className="form-group">
                    <label htmlFor="shopName">Shop Name</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.shopName ? 'is-invalid' : validFields.shopName ? 'is-valid' : ''}`}
                      id="shopName"
                      placeholder="Enter shop name"
                      value={shopName}
                      onChange={(e) => setShopName(e.target.value)}
                      onBlur={(e) => validateField('shopName', e.target.value)}
                    />
                    {errors.shopName && <small className="text-danger">{errors.shopName}</small>}
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className="form-group">
                    <label htmlFor="GSTNumber">GST Number</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.GSTNumber ? 'is-invalid' : validFields.GSTNumber ? 'is-valid' : ''}`}
                      id="GSTNumber"
                      placeholder="Enter GST number"
                      value={GSTNumber}
                      onChange={(e) => setGstNumber(e.target.value)}
                      maxLength="15"
                      pattern="\d*"
                      inputMode="numeric"
                      onBlur={(e) => validateField('GSTNumber', e.target.value)}
                    />
                    {errors.GSTNumber && <small className="text-danger">{errors.GSTNumber}</small>}
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className="form-group">
                    <label htmlFor="phoneNumber">Phone Number</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.phoneNumber ? 'is-invalid' : validFields.phoneNumber ? 'is-valid' : ''}`}
                      id="phoneNumber"
                      placeholder="Enter phone number"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      maxLength="10"
                      pattern="\d*"
                      inputMode="numeric"
                      onBlur={(e) => validateField('phoneNumber', e.target.value)}
                    />
                    {errors.phoneNumber && <small className="text-danger">{errors.phoneNumber}</small>}
                  </div>
                </div>
                <div className="col-md-4">
                  <label>Profile Image</label>
                  <span style={{ color: 'red' }}>*</span>
                  <label className="vendor-upload-label" htmlFor="profile-image-upload-button">
                    <Input
                      accept="image/*"
                      id="profile-image-upload-button"
                      type="file"
                      name="profileImage"
                      onChange={handleProfileImageChange}
                    />
                    <Button
                      variant="contained"
                      component="span"
                      className="vendor-field-action"
                      endIcon={
                        files.profileImage ? (
                          <>
                            <span style={{ fontSize: '15px' }}>{files.profileImage.name || 'Existing Image'}</span>
                            <img
                              src={removeIcon}
                              alt="Remove File Icon"
                              style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                              onClick={(e) => { e.stopPropagation(); handleFileRemove('profileImage'); }}
                            />
                          </>
                        ) : (
                          <img src={uploadicon} alt="Upload Icon" style={{ width: '20px', height: '20px' }} />
                        )
                      }
                      style={{ color: 'white' }}
                    >
                      {files.profileImage ? '' : 'Upload'}
                    </Button>
                  </label>
                  {files.profileImage?.preview && (
                    <img src={files.profileImage.preview} alt="Profile Preview" style={{ width: '100px', height: '100px', marginTop: '10px' }} />
                  )}
                  {errors.profileImage && <small className="text-danger">{errors.profileImage}</small>}
                </div>
                <div className='col-md-4'>
                  <label htmlFor='country'>Country</label>
                  <span style={{ color: 'red' }}>*</span>
                  <select
                    id='country'
                    className={`form-select bg-light ${errors.country ? 'is-invalid' : validFields.country ? 'is-valid' : ''}`}
                    style={{ color: 'gray' }}
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    onBlur={(e) => validateField('country', e.target.value)}
                  >
                    <option value=''>Select Country</option>
                    <option value='India'>India</option>
                    {country && country !== 'India' && <option value={country}>{country}</option>}
                  </select>
                  {errors.country && <small className="text-danger">{errors.country}</small>}
                </div>
                <div className='col-md-4'>
                  <label htmlFor='state'>State</label>
                  <span style={{ color: 'red' }}>*</span>
                  <select
                    id='state'
                    className={`form-select bg-light ${errors.state ? 'is-invalid' : validFields.state ? 'is-valid' : ''}`}
                    style={{ color: 'gray' }}
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    onBlur={(e) => validateField('state', e.target.value)}
                  >
                    <option value=''>Select State</option>
                    <option value='Tamil Nadu'>Tamil Nadu</option>
                  </select>
                  {errors.state && <small className="text-danger">{errors.state}</small>}
                </div>
                <div className='col-md-4'>
                  <label htmlFor='city'>City</label>
                  <span style={{ color: 'red' }}>*</span>
                  <select
                    id='city'
                    className={`form-select bg-light ${errors.city ? 'is-invalid' : validFields.city ? 'is-valid' : ''}`}
                    style={{ color: 'gray' }}
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    onBlur={(e) => validateField('city', e.target.value)}
                  >
                    <option value=''>Select City</option>
                    <option value='Rajapalayam'>Rajapalayam</option>
                    <option value='Sankarankovil'>Sankarankovil</option>
                  </select>
                  {errors.city && <small className="text-danger">{errors.city}</small>}
                </div>
                {/* <div className='col-md-4'>
                  <label htmlFor='useMyLocation'>Use My Location</label>
                  <span style={{ color: 'red' }}>*</span>
                  <button
                    type='button'
                    id='useMyLocation'
                    className={`btn d-flex justify-content-between align-items-center ${errors.useMyLocation ? 'border-danger' : validFields.useMyLocation ? 'border-success' : ''}`}
                    style={{ backgroundColor: '#00B982', color: 'white', width: '100%' }}
                    onClick={handleLocationClick}
                  >
                    <span>{isLocationPicked ? 'Location Picked' : 'Live Location'}</span>
                    <img src={location} alt="location" style={{ width: '20px', height: '20px' }} />
                  </button>
                  {useMyLocation.latitude && useMyLocation.longitude && (
                    <div style={{ marginTop: '10px' }}>
                      <small>Latitude: {useMyLocation.latitude}</small><br />
                      <small>Longitude: {useMyLocation.longitude}</small>
                    </div>
                  )}
                  {errors.useMyLocation && <small className="text-danger">{errors.useMyLocation}</small>}
                </div> */}
                 {/* === USE MY LOCATION WITH MAP === */}
                          <div className='col-md-4'>
                            <label>Use My Location <span style={{ color: 'red' }}>*</span></label>
                            <button
                              type='button'
                              className={`vendor-field-action d-flex justify-content-between align-items-center w-100 ${errors.useMyLocation ? 'border-danger' : validFields.useMyLocation ? 'border-success' : ''}`}
                              onClick={() => setIsMapOpen(true)}
                            >
                              <span>
                                {useMyLocation.latitude
                                  ? `Picked: ${parseFloat(useMyLocation.latitude).toFixed(4)}, ${parseFloat(useMyLocation.longitude).toFixed(4)}`
                                  : 'Select Location on Map'}
                              </span>
                              <img src={location} alt="location" style={{ width: '20px', height: '20px' }} />
                            </button>
                            {errors.useMyLocation && <small className="text-danger">{errors.useMyLocation}</small>}
                          </div>
                
                          {/* === MAP MODAL === */}
                          <div className={`modal fade vendor-map-modal ${isMapOpen ? 'show d-block' : ''}`} tabIndex="-1">
                            <div className="modal-dialog modal-lg modal-dialog-centered vendor-map-dialog">
                              <div className="modal-content vendor-map-content">
                                <div className="modal-header vendor-map-header">
                                  <div>
                                    <p>Vendors</p>
                                    <h5 className="modal-title">Select location</h5>
                                  </div>
                                  <button type="button" className="btn-close" onClick={() => setIsMapOpen(false)}></button>
                                </div>
                                <div className="modal-body vendor-map-body">
                                  <p className="vendor-map-hint">Search an address, enter coordinates, or click the map to drop a pin.</p>
                                  <div className="vendor-map-search">
                                    <input
                                      className="form-control"
                                      placeholder="Search address..."
                                      value={searchQuery}
                                      onChange={e => setSearchQuery(e.target.value)}
                                      onKeyDown={e => e.key === 'Enter' && handleGeocode()}
                                    />
                                    <button type="button" className="vendor-map-search-btn" onClick={handleGeocode} disabled={!searchQuery.trim()}>
                                      Search
                                    </button>
                                  </div>
                
                                  <div className="vendor-map-coords">
                                    <div>
                                      <label>Latitude</label>
                                      <input type="number" step="any" className="form-control" value={manualLat}
                                        onChange={e => {
                                          setManualLat(e.target.value);
                                          if (e.target.value && manualLng) updateLocation({ lat: +e.target.value, lng: +manualLng });
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <label>Longitude</label>
                                      <input type="number" step="any" className="form-control" value={manualLng}
                                        onChange={e => {
                                          setManualLng(e.target.value);
                                          if (e.target.value && manualLat) updateLocation({ lat: +manualLat, lng: +e.target.value });
                                        }}
                                      />
                                    </div>
                                  </div>
                
                                  <div className="vendor-map-frame">
                                    <MapContainer center={mapCenter} zoom={mapZoom} ref={mapRef} style={{ height: "100%" }}>
                                      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                      <MapClickHandler onSelect={updateLocation} />
                                      {selectedLocation && <Marker position={[selectedLocation.lat, selectedLocation.lng]} />}
                                    </MapContainer>
                                  </div>
                                </div>
                                <div className="modal-footer vendor-map-footer">
                                  <button type="button" className="vendor-map-cancel" onClick={() => setIsMapOpen(false)}>Cancel</button>
                                  <button type="button" className="vendor-map-confirm" disabled={!selectedLocation} onClick={confirmLocation}>
                                    Confirm Location
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                
                <div className='col-md-4'>
                  <label htmlFor='currentLocation'>Current Location</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type='text'
                    id='currentLocation'
                    className={`form-control bg-light ${errors.currentLocation ? 'is-invalid' : validFields.currentLocation ? 'is-valid' : ''}`}
                    placeholder='Current location'
                    value={currentLocation}
                    onChange={(e) => setCurrentLocation(e.target.value)}
                    onBlur={(e) => validateField('currentLocation', e.target.value)}
                  />
                  {errors.currentLocation && <small className="text-danger">{errors.currentLocation}</small>}
                </div>
                <div className='col-md-4'>
                  <label htmlFor='emailAddress'>Email Address</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type='email'
                    id='emailAddress'
                    className={`form-control bg-light ${errors.emailAddress ? 'is-invalid' : validFields.emailAddress ? 'is-valid' : ''}`}
                    placeholder='Email Address'
                    value={emailAddress}
                    onChange={(e) => setEmailAddress(e.target.value)}
                    onBlur={(e) => validateField('emailAddress', e.target.value)}
                  />
                  {errors.emailAddress && <small className="text-danger">{errors.emailAddress}</small>}
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="address">Address</label>
                    <span style={{ color: 'red' }}>*</span>
                    <textarea
                      id="address"
                      className={`form-control bg-light ${errors.address ? 'is-invalid' : validFields.address ? 'is-valid' : ''}`}
                      rows="1"
                      placeholder="Enter address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      onBlur={(e) => validateField('address', e.target.value)}
                    ></textarea>
                    {errors.address && <small className="text-danger">{errors.address}</small>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 buttonsgap">
                  <label>Time Availability Slot</label>
                  <span style={{ color: 'red' }}>*</span>
                  <div className="btn-group" role="group" aria-label="Time Availability Slot">
                    {['6:00 AM - 10:00 PM', '11:00 AM - 8:00 PM', '9:00 AM - 9:00 PM', '9:30 AM - 10:00 PM', '10:00 AM - 10:00 PM', '12:00 AM - 11:59 PM'].map(time => (
                      <button
                        key={time}
                        type="button"
                        className={`bg-light btn btn-outline-secondary slot-btn ${timeAvailabilitySlots.includes(time) ? 'active' : ''} ${errors.timeAvailabilitySlots ? 'border-danger' : validFields.timeAvailabilitySlots ? 'border-success' : ''}`}
                        onClick={() => handleButtonClick(time)}
                        style={{ borderRadius: '4px' }}
                      >
                        {time}
                      </button>
                    ))}
                  </div>
                  {errors.timeAvailabilitySlots && <small className="text-danger">{errors.timeAvailabilitySlots}</small>}
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 buttonsgap">
                  <label>Day Slot</label>
                  <span style={{ color: 'red' }}>*</span>
                  <div className="btn-group" role="group" aria-label="Day Slot">
                    {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => (
                      <button
                        key={day}
                        type="button"
                        className={`bg-light btn btn-outline-secondary slot-btn ${daySlots.includes(day) ? 'active' : ''} ${errors.daySlots ? 'border-danger' : validFields.daySlots ? 'border-success' : ''}`}
                        onClick={() => handleDaysButtonClick(day)}
                        style={{ borderRadius: '4px' }}
                      >
                        {day}
                      </button>
                    ))}
                  </div>
                  {errors.daySlots && <small className="text-danger">{errors.daySlots}</small>}
                </div>
              </div>
            </div>
          </div>
          <div className="vendor-form-card">
            <div className="vendor-form-card-head">
              <div>
                <h2>Vendor Documents</h2>
                <p>Upload licenses and identity documents.</p>
              </div>
            </div>
            <div className="vendor-form-card-body">
              <table className="table">
                <thead>
                  <tr>
                    <th>Document Name <span style={{ color: 'red' }}>*</span></th>
                    <th>Document Number <span style={{ color: 'red' }}>*</span></th>
                    <th>Document Type <span style={{ color: 'red' }}>*</span></th>
                    <th>Document Upload <span style={{ color: 'red' }}>*</span></th>
                    <th>Document Expiry Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {documents.map((doc, index) => (
                    <tr key={index}>
                      <td>
                        <select
                          className={`form-control bg-light ${errors[`documentname${index}`] ? 'is-invalid' : validFields[`documentname${index}`] ? 'is-valid' : ''}`}
                          value={doc.name}
                          onChange={(e) => handleChange(index, 'name', e.target.value)}
                          onBlur={(e) => validateField(`documentname${index}`, e.target.value)}
                          style={{
                            backgroundImage: `url(${arrow})`,
                            backgroundPosition: 'right 10px center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '16px 16px',
                            paddingRight: '30px',
                            color: 'gray',
                          }}
                        >
                          <option value="">Select Document Name</option>
                          {getAvailableDocumentNames(index).map((name) => (
                            <option key={name} value={name}>{name}</option>
                          ))}
                        </select>
                        {errors[`documentname${index}`] && <small className="text-danger">{errors[`documentname${index}`]}</small>}
                      </td>
                      <td>
                        <input
                          type="text"
                          className={`form-control bg-light ${errors[`documentnumber${index}`] ? 'is-invalid' : validFields[`documentnumber${index}`] ? 'is-valid' : ''}`}
                          value={doc.number}
                          placeholder="Enter Document Number"
                          onChange={(e) => handleChange(index, 'number', e.target.value)}
                          onBlur={(e) => validateField(`documentnumber${index}`, e.target.value)}
                        />
                        {errors[`documentnumber${index}`] && <small className="text-danger">{errors[`documentnumber${index}`]}</small>}
                      </td>
                      <td>
                        <select
                          className={`form-control bg-light ${errors[`documenttype${index}`] ? 'is-invalid' : validFields[`documenttype${index}`] ? 'is-valid' : ''}`}
                          value={doc.type}
                          onChange={(e) => handleChange(index, 'type', e.target.value)}
                          onBlur={(e) => validateField(`documenttype${index}`, e.target.value)}
                          style={{
                            backgroundImage: `url(${arrow})`,
                            backgroundPosition: 'right 10px center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '16px 16px',
                            paddingRight: '30px',
                            color: 'gray',
                          }}
                        >
                          <option value="">Select From List</option>
                          <option value="pdf">PDF</option>
                          <option value="doc">DOC</option>
                          <option value="jpg">JPG</option>
                          <option value="png">PNG</option>
                          <option value="jpeg">JPEG</option>
                        </select>
                        {errors[`documenttype${index}`] && <small className="text-danger">{errors[`documenttype${index}`]}</small>}
                      </td>
                      <td>
                        <label
                          className="vendor-upload-label"
                          htmlFor={doc.type ? `file-upload-${index}` : undefined}
                          onClick={(event) => {
                            if (!doc.type) event.preventDefault();
                          }}
                        >
                          <input
                            type="file"
                            id={`file-upload-${index}`}
                            style={{ display: 'none' }}
                            accept={documentTypeAccept[doc.type] || ''}
                            onChange={(e) => handleFileChange(index, e)}
                          />
                          {doc.upload || doc.preview ? (
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                              <button
                                type="button"
                                className={`vendor-field-action ${errors[`documentupload${index}`] ? 'border-danger' : validFields[`documentupload${index}`] ? 'border-success' : ''}`}
                                onClick={() => handleClearFile(index)}
                              >
                                <span style={{ flex: 1, textAlign: 'center' }}>{doc.upload?.name || 'Existing File'}</span>
                                <img src={deleteicon} alt="Cancel" style={{ width: '20px', height: '20px' }} />
                              </button>
                            </div>
                          ) : (
                            <button
                              type="button"
                              className={`vendor-field-action ${errors[`documentupload${index}`] ? 'border-danger' : ''}`}
                              disabled={!doc.type}
                              onClick={() => {
                                if (!doc.type) {
                                  validateField(`documenttype${index}`, '');
                                  return;
                                }
                                document.getElementById(`file-upload-${index}`).click();
                              }}
                            >
                              <span>Upload</span>
                              <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px' }} />
                            </button>
                          )}
                        </label>
                        {(doc.upload || doc.preview) && renderDocumentPreview(doc)}
                        {errors[`documentupload${index}`] && <small className="text-danger">{errors[`documentupload${index}`]}</small>}
                      </td>
                      <td>
                        <input
                          type="date"
                          className="form-control bg-light"
                          value={doc.expiryDate}
                          onChange={(e) => handleChange(index, 'expiryDate', e.target.value)}
                        />
                      </td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <p onClick={addRow} style={{ margin: 0, cursor: 'pointer' }}>
                            <img src={add} alt="Add" style={{ width: '34px', height: '34px' }} />
                          </p>
                          <button
                            className="btn btn-danger btn-sm rounded-circle"
                            onClick={() => deleteRow(index)}
                            style={{ width: '30px', height: '30px' }}
                          >
                            <img src={deleteicon} alt="Delete" style={{ width: '16px', height: '16px', marginTop: '-5px', marginLeft: '-2px' }} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="vendor-form-card">
            <div className="vendor-form-card-head">
              <div>
                <h2>Vendor Products</h2>
                <p>Choose consumable type, categories, and products.</p>
              </div>
            </div>
            <div className="vendor-form-card-body">
              <div className="row">
                <div className="col-md-4">
                  <label>Toggle Both</label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="toggleBoth"
                      checked={consumable === 'Both'}
                      onChange={(e) => handleConsumableClick(e.target.checked ? 'Both' : 'Perishable')}
                      style={{
                        backgroundColor: consumable === 'Both' ? '#31a87e' : '',
                        borderColor: consumable === 'Both' ? '#31a87e' : '',
                      }}
                    />
                    <label className="form-check-label" htmlFor="toggleBoth">
                      Both (On/Off)
                    </label>
                  </div>
                </div>
                <div className="col-md-4">
                  <label>Consumables</label>
                  <span style={{ color: 'red' }}>*</span> <br />
                  <div className="btn-group bg-light" role="group" aria-label="Consumable">
                    <button
                      type="button"
                      className={`btn btn-outline-secondary ${consumable === 'Perishable' || consumable === 'Both' ? 'active' : ''} ${errors.consumable ? 'border-danger' : validFields.consumable ? 'border-success' : ''}`}
                      onClick={() => handleConsumableClick('Perishable')}
                      disabled={consumable === 'Both'}
                    >
                      Perishable
                    </button>
                    <button
                      type="button"
                      className={`btn btn-outline-secondary ${consumable === 'Non-Perishable' || consumable === 'Both' ? 'active' : ''} ${errors.consumable ? 'border-danger' : validFields.consumable ? 'border-success' : ''}`}
                      onClick={() => handleConsumableClick('Non-Perishable')}
                      disabled={consumable === 'Both'}
                    >
                      Non-Perishable
                    </button>
                  </div>
                  {errors.consumable && <small className="text-danger">{errors.consumable}</small>}
                </div>
                <div className="col-md-4">
                  <div className="custom-select-container" ref={categoriesSelectRef}>
                    <label htmlFor="categories">Categories</label>
                    <span style={{ color: 'red' }}>*</span>
                    <div className={`custom-select ${errors.categories ? 'border-danger' : validFields.categories ? 'border-success' : ''}`}>
                      <div className="custom-select-header bg-light" onClick={toggleDropdown}>
                        {selectedOptions.length > 0
                          ? categories
                            .filter((category) => selectedOptions.includes(category._id))
                            .map((category) => category.categoryName)
                            .join(', ')
                          : 'Select Category'}
                      </div>
                      {isOpen && (
                        <div
                          className={`custom-select-options ${categoriesOpenAbove ? 'open-above' : ''}`}
                          onMouseDown={(event) => event.stopPropagation()}
                        >
                          {categories.map((category) => (
                            <label key={category._id} className="custom-select-option">
                              <input
                                type="checkbox"
                                checked={selectedOptions.includes(category._id)}
                                onChange={() => toggleOption(category._id)}
                              />
                              {category.categoryName}
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                    {errors.categories && <small className="text-danger">{errors.categories}</small>}
                  </div>
                </div>
                {selectedOptions.map((selectedOptionId) => {
                  const selectedOption = categories.find((category) => category._id === selectedOptionId);
                  if (!selectedOption) return null;

                  const categoryName = selectedOption.categoryName;
                  const allProducts = productsByCategory[categoryName] || [];
                  const options = allProducts.length > 0
                    ? allProducts.map((product) => ({
                        value: product._id,
                        label: product.productName,
                      }))
                    : [{ value: '', label: 'No products available', isDisabled: true }];

                  return (
                    <div className="col-md-4" key={selectedOption._id}>
                      <div className="custom-select-container">
                        <label>{categoryName}</label>
                        <span style={{ color: 'red' }}>*</span>
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          components={{ Option: ProductCheckboxOption }}
                          classNamePrefix="react-select"
                          options={options}
                          className={`form-select mt-2 ${errors[`products${selectedOptionId}`] ? 'is-invalid' : validFields[`products${selectedOptionId}`] ? 'is-valid' : ''}`}
                          placeholder="Select Product"
                          value={options.filter(option => selectedProducts[selectedOptionId]?.includes(option.value))}
                          onChange={(selectedOptions) => {
                            const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                            handleProductChange(selectedOptionId, selectedValues);
                          }}
                          onFocus={() => {
                            if (!productsByCategory[categoryName]) {
                              getProductsByCategory(categoryName);
                            }
                          }}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          maxMenuHeight={200}
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              backgroundImage: `url(${arrow})`,
                              backgroundPosition: 'right 10px center',
                              backgroundRepeat: 'no-repeat',
                              backgroundSize: '16px 16px',
                              paddingRight: '30px',
                              color: 'gray',
                            }),
                            indicatorsContainer: () => ({ display: 'none' }),
                            menuPortal: (provided) => ({ ...provided, zIndex: 10000000 }),
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 10000000,
                              maxHeight: 200,
                              boxShadow: '0 12px 30px rgba(16, 64, 52, 0.16)',
                              border: '1px solid #d5e4de',
                              borderRadius: '12px',
                              overflow: 'hidden',
                            }),
                            menuList: (provided) => ({
                              ...provided,
                              maxHeight: 200,
                              padding: '6px',
                              boxSizing: 'border-box',
                              overflowY: 'auto',
                              overflowX: 'hidden',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              marginBottom: 2,
                              borderRadius: 8,
                              backgroundColor: state.isSelected ? '#edf9f5' : state.isFocused ? '#f4fbf8' : '#fff',
                              color: state.isSelected ? '#0f8a62' : '#1c2b27',
                              fontWeight: state.isSelected ? 600 : 500,
                              cursor: 'pointer',
                            }),
                          }}
                        />
                        {errors[`products${selectedOptionId}`] && <small className="text-danger">{errors[`products${selectedOptionId}`]}</small>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="vendor-form-actions">
            <button type="button" className="vendor-form-cancel" onClick={goBackToVendors}>Cancel</button>
            <button type="button" className="vendor-form-submit" onClick={handleUpdateVendor}>Update</button>
          </div>
        </div>
        <div className="vendor-form-footer">
          <Footer />
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{ zIndex: 9999 }}
        />
      </div>
    </>
  );
};

export default UpdateProductVendor;